import type { ViewMode } from "@/shared/config/routes";

export const entryStatusSubtabs = [
	{ id: "tracked", label: "Tracked", values: ["tracked", "reviewed"] },
	{ id: "exported", label: "Exported", values: ["exported"] },
	{ id: "deleted", label: "Deleted", values: ["deleted"] },
] as const;

export type EntryStatusSubtab = (typeof entryStatusSubtabs)[number];
export type EntryStatusSubtabId = EntryStatusSubtab["id"];
export type EntryStatusView = Extract<ViewMode, "entries" | "calendar">;

function hasSameValues(a: readonly string[], b: readonly string[]): boolean {
	return a.length === b.length && a.every((value) => b.includes(value));
}

export function getActiveEntryStatus(
	statusValues: readonly string[],
): EntryStatusSubtabId | null {
	return (
		entryStatusSubtabs.find((subtab) =>
			hasSameValues(statusValues, subtab.values),
		)?.id ?? null
	);
}

export function isEntryStatusView(view: ViewMode): view is EntryStatusView {
	return view === "entries" || view === "calendar";
}

export function getEntryStatusSubtabState(
	itemView: ViewMode,
	activeView: ViewMode,
	statusValues: readonly string[],
) {
	const activeStatus = getActiveEntryStatus(statusValues);
	return {
		isVisible: isEntryStatusView(itemView) && itemView === activeView,
		items: entryStatusSubtabs.map((subtab) => ({
			...subtab,
			isActive: subtab.id === activeStatus,
		})),
	};
}
